/**
 * @generated SignedSource<<f523b1d3626057a30277927a1ddd539e>>
 * @relayHash 9f5add8c554cee4aa25bd65ef402579c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 45e434683e79a84d6f76d9e5e7cf2c4d47020e40b0df83b10e143dee2dd76cbe

import type { ConcreteRequest } from 'relay-runtime';
export type queryTypedChildrenContentQuery$variables = {
  id: string;
  pageOffset: number;
  pageSize: number;
  type: string;
};
export type queryTypedChildrenContentQuery$data = {
  readonly content: {
    readonly nodes: ReadonlyArray<{
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly body: {
            readonly atlas_doc_format: {
              readonly value: string | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly title: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
};
export type queryTypedChildrenContentQuery = {
  response: queryTypedChildrenContentQuery$data;
  variables: queryTypedChildrenContentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageOffset"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageSize"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "type"
},
v4 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v5 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "pageSize"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "pageOffset"
  },
  {
    "kind": "Variable",
    "name": "type",
    "variableName": "type"
  }
],
v6 = {
  "concreteType": "PageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasNextPage"
    }
  ]
},
v7 = {
  "concreteType": "ContentBodyPerRepresentation",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": [
    {
      "concreteType": "ContentBody",
      "kind": "LinkedField",
      "name": "atlas_doc_format",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ]
    }
  ]
},
v8 = {
  "kind": "ScalarField",
  "name": "title"
},
v9 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "queryTypedChildrenContentQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "queryTypedChildrenContentQuery",
    "selections": [
      {
        "args": (v4/*: any*/),
        "concreteType": "PaginatedContentListWithChild",
        "kind": "LinkedField",
        "name": "content",
        "plural": false,
        "selections": [
          {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              {
                "args": (v5/*: any*/),
                "concreteType": "PaginatedContentList",
                "kind": "LinkedField",
                "name": "children",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/)
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "45e434683e79a84d6f76d9e5e7cf2c4d47020e40b0df83b10e143dee2dd76cbe",
    "metadata": {},
    "name": "queryTypedChildrenContentQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "0e23ecd85c3b1faf715343e340dca31c";

export default node;
